import { render } from "./EditSideBar.vue?vue&type=template&id=000df0a0&scoped=true"
import script from "./EditSideBar.vue?vue&type=script&lang=js"
export * from "./EditSideBar.vue?vue&type=script&lang=js"

import "./EditSideBar.vue?vue&type=style&index=0&id=000df0a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000df0a0"]])

export default __exports__